/// <reference types="@angular/localize" />

import { enableProdMode, inject, provideAppInitializer } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { routes } from 'app/app.routes';
import { provideCore } from 'app/core/core';
import { ExternalLinkEnhancer } from 'app/core/directives/external-link-indicator.directive';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    ...provideCore({ routes }),
    provideAppInitializer(() => inject(ExternalLinkEnhancer).init()),
  ],
}).catch((err) => {
  // console.error(err);
});
